import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router";
import axios from "axios";
import $ from "jquery";

import "../css/users.css";
import { FiHome } from "react-icons/fi";

import HeaderSearchBar from "../components/headerSearchBar";

export default function SearchUser() {

    let { username } = useParams();

    const [ socialname, setSocialName ] = useState("");
    const [ bio, setBio ] = useState("O usuário não possui bio");

    useEffect(() => {
        axios.get(`https://cloudify-backend.herokuapp.com/users/get/byusername/${username}`)
        .then(resp => {
            var data = resp.data;
            var userInfo = resp.data.userInfo;

            setSocialName(userInfo.socialname)
            document.getElementById("visitantUserPicture").src = userInfo.profilePicture;

            if(data.userInfo.bio) setBio(userInfo.bio);

            var history = userInfo.browserHistory;

            history.forEach(searchedBook => {

                axios.get(`https://www.googleapis.com/books/v1/volumes/${searchedBook.bookId}`)
                .then(resp => {
                    var volumeInfo = resp.data.volumeInfo;
                    $("#booksHolder").append(` <div id="generatedBookDisplayer"> <img src="${volumeInfo.imageLinks.thumbnail}" /> </div> `)
                })
            });
        });
    }, []);

    return (
        <div className="app">

            <HeaderSearchBar />

            <div className="centered">
                <div id="userForm">

                    <Link to="/" > <FiHome style={{"color":"white", "fontSize":"32px"}} /> </Link>

                    <div className="centered">
                        <h2 id="usernameDisplayer">@{username}</h2>
                    </div>

                    <div id="userInfoHandler">

                        <div className="centered">
                            <img src="https://i.ibb.co/px3GVFk/icon-rounded.png" id="visitantUserPicture" />
                        </div>

                        <div className="centered">
                            <h1>{socialname}</h1>
                        </div>

                        <div className="centered" id="bioText">
                            <h2>{bio}</h2>
                        </div>
                    </div>

                    <link
                        rel="stylesheet"
                        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.14.0/css/all.min.css"
                        integrity="sha512-1PKOgIY59xJ8Co8+NE6FZ+LOAZKjy+KY8iq0G4B3CyeY6wYHN3yt9PW0XpSriVlkMXe40PTKnXrLnZ9+fkDaog=="
                        crossorigin="anonymous"
                    />

                    <div className="centered">
                        <h1>Livros pesquisados</h1>
                    </div>

                    <div className="centered">
                        <div id="booksHolder" />
                    </div>
                </div>
            </div>
        </div>
    )
}